import { Alert, Button, Card, Field, Input } from "@aman/design-system";
import { type FormEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { api, asApiError, type ApiError } from "../api/client";
import { objectFromPayload, stringValue } from "../types";
import { ApiErrorAlert } from "./common";

export function VoucherRedeemer({ onRedeemed }: { onRedeemed: () => Promise<void> | void }) {
  const { t } = useTranslation();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<ApiError>();
  const [result, setResult] = useState<{ credits: string; balance: string }>();

  const submit = async (event: FormEvent): Promise<void> => {
    event.preventDefault();
    if (!/^[0-9]{12}$/u.test(code)) return;
    setBusy(true);
    setError(undefined);
    setResult(undefined);
    try {
      const data = objectFromPayload(await api.post<unknown>("/vouchers/redeem", { code }));
      setResult({ credits: stringValue(data["credits"], "0"), balance: stringValue(data["balance"], "0") });
      setCode("");
      await onRedeemed();
    } catch (caught) {
      setError(asApiError(caught));
    } finally {
      setBusy(false);
    }
  };

  return <Card title={t("pages.vouchers.redeemTitle")} description={t("pages.vouchers.redeemDescription")}>
    <ApiErrorAlert error={error} />
    {result !== undefined ? <Alert tone="success">{t("pages.vouchers.redeemed", result)}</Alert> : null}
    <form className="voucher-redeem" onSubmit={(event) => void submit(event)}>
      <Field label={t("pages.vouchers.code")} hint={t("pages.vouchers.codeHint")}>
        <Input required inputMode="numeric" autoComplete="one-time-code" dir="ltr" minLength={12} maxLength={12}
          pattern="[0-9]{12}" value={code}
          onChange={(event) => setCode(event.target.value.replace(/[^0-9]/gu, "").slice(0, 12))} />
      </Field>
      <Button type="submit" busy={busy} disabled={code.length !== 12}>{t("pages.vouchers.redeem")}</Button>
    </form>
  </Card>;
}
